/**
 * @internal true
 * @module briefing/BriefingMediaWall
 * Widget do Mural TV — embed compacto do AcMediaPlayer.
 * Reusa AcMediaPlayer em modo compact quando dados disponíveis,
 * caso contrário exibe estado informativo.
 */
import { Tv, Maximize2, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface BriefingMediaWallProps {
  /** Se true, renderiza o player. Se false, exibe placeholder */
  hasMediaData: boolean;
}

export function BriefingMediaWall({ hasMediaData }: BriefingMediaWallProps) {
  const navigate = useNavigate();

  return (
    <div className="brief-card">
      <div className="brief-card-head">
        <h3 className="brief-card-title">
          <Tv style={{ color: '#8b5cf6' }} />
          Mural TV
        </h3>
        <button
          className="brief-card-link"
          onClick={() => navigate('/tv')}
        >
          Tela cheia <ChevronRight size={12} />
        </button>
      </div>
      <div className="brief-card-body">
        <div className="brief-media-wrap">
          {/* Gradiente placeholder premium — quando feed real existir,
              importar AcMediaPlayer mode="compact" aqui */}
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 40%, #312e81 100%)',
            color: '#fff',
            gap: 10,
            padding: 20,
            textAlign: 'center',
          }}>
            <Tv size={36} style={{ opacity: 0.3 }} />
            <div style={{ fontSize: '0.88rem', fontWeight: 800, opacity: 0.9 }}>
              Mural Digital
            </div>
            <div style={{ fontSize: '0.72rem', opacity: 0.55, maxWidth: 260, lineHeight: 1.5 }}>
              Comunicados, publicações e enquetes da escola serão exibidos aqui em tempo real.
            </div>
            <button
              onClick={() => navigate('/tv')}
              style={{
                marginTop: 8,
                padding: '8px 18px',
                borderRadius: 10,
                background: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.15)',
                color: '#fff',
                fontSize: '0.72rem',
                fontWeight: 700,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
              }}
            >
              <Maximize2 size={13} />
              Abrir TV em Tela Cheia
            </button>
          </div>

          {/* Botão flutuante expandir */}
          <button
            className="brief-media-expand"
            onClick={() => navigate('/tv')}
            title="Expandir para tela cheia"
          >
            <Maximize2 size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
